import { AxiosResponse } from 'axios';
import { axiosAuthInstance } from '../../instance.ts';
import {
  IAgencyProfile,
  IAgencyStatistic,
  ICreateAgencyProfileRequest,
  IMemberCompact,
  IUpdateRecruiterProfileRequest,
} from './types.ts';

const AgencyAPI = {
  getOne: (id: string): Promise<AxiosResponse<IAgencyProfile, void>> =>
    axiosAuthInstance.get(`/agency/${id}/`),

  getMyAgency: (): Promise<AxiosResponse<IAgencyProfile, void>> =>
    axiosAuthInstance.get('/agency/me/'),

  getMyAgencyStatistic: (): Promise<AxiosResponse<IAgencyStatistic, void>> =>
    axiosAuthInstance.get('/agency/me/entities-count/'),

  getAgenciesCompact: (): Promise<
    AxiosResponse<
      { id: number; displayName: string; imageKey: string; avatarSignedUrl: string }[],
      void
    >
  > => axiosAuthInstance.get('/agency/all-compact'),

  getMembersCompact: (): Promise<AxiosResponse<IMemberCompact[], void>> =>
    axiosAuthInstance.get('/agency/members-compact/'),

  create: (
    payload: ICreateAgencyProfileRequest,
  ): Promise<AxiosResponse<IAgencyProfile, ICreateAgencyProfileRequest>> =>
    axiosAuthInstance.post('/agency/', { ...payload }),

  update: (
    id: number,
    payload: IUpdateRecruiterProfileRequest,
  ): Promise<AxiosResponse<IAgencyProfile, IUpdateRecruiterProfileRequest>> =>
    axiosAuthInstance.patch(`/agency/${id}/`, payload),

  validateCRN: (crn: string): Promise<AxiosResponse<void, void>> =>
    axiosAuthInstance.post(`/agency/validate-crn/${crn}`),
};

export default AgencyAPI;
